var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 128,
    viewBox: "0 0 124 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Firefox SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.505 42.9794C116.808 36.4928 111.337 29.4891 107.053 27.2751C110.108 33.1885 112.228 39.5391 113.339 46.1011L113.35 46.2052C106.332 28.7239 94.4353 21.6641 84.7136 6.31199C84.2219 5.53558 83.7302 4.75757 83.2513 3.93633C82.9774 3.46728 82.758 3.04466 82.5674 2.65565C82.1643 1.87532 81.8536 1.05065 81.6417 0.198348C81.642 0.159018 81.6278 0.120961 81.6018 0.091435C81.5758 0.0619091 81.5398 0.0429815 81.5007 0.0382629C81.4625 0.027773 81.4221 0.027773 81.3838 0.0382629C81.3758 0.0382629 81.363 0.0526705 81.3534 0.0558722C81.3438 0.0590739 81.323 0.0734816 81.3085 0.079885L81.3326 0.0382629C65.741 9.1631 60.4477 26.0521 59.9672 34.5045C53.7385 34.9314 47.7831 37.2248 42.8781 41.0856C42.3666 40.6525 41.8319 40.2475 41.2765 39.8722C39.8623 34.9239 39.802 29.6869 41.102 24.7073C35.376 27.4797 30.2882 31.41 26.1606 36.2495H26.1318C23.6717 33.1326 23.8447 22.8552 23.9856 20.7084C23.2579 21.0008 22.5632 21.3694 21.9132 21.8082C19.7414 23.3574 17.7112 25.0958 15.8463 27.003C13.7211 29.1566 11.7801 31.4844 10.0437 33.9619V33.9715V33.9603C6.05337 39.6138 3.2228 46.0014 1.71538 52.7542L1.63209 53.164C1.51518 53.7099 1.09395 56.4442 1.02188 57.0381C1.02188 57.0845 1.01227 57.1277 1.00747 57.1742C0.464122 59.997 0.127427 62.8557 6.10352e-05 65.7275V66.0477C0.0274938 81.5736 5.87728 96.5251 16.3946 107.951C26.912 119.376 41.3326 126.446 56.8098 127.763C72.287 129.081 87.696 124.551 99.995 115.068C112.294 105.585 120.589 91.8373 123.243 76.5396C123.347 75.7392 123.432 74.9468 123.525 74.1384C124.804 63.5758 123.42 52.8613 119.499 42.9698L119.505 42.9794ZM47.9616 91.5492C48.2515 91.6885 48.5238 91.839 48.8217 91.9718L48.8649 91.999C48.5638 91.855 48.2627 91.705 47.9616 91.5492ZM113.352 46.2228V46.1635L113.363 46.2292L113.352 46.2228Z",
    fill: "url(#paint0_linear_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M119.505 42.9795C116.808 36.4928 111.337 29.4891 107.053 27.2751C110.108 33.1885 112.228 39.5391 113.339 46.1011V46.1604L113.35 46.226C118.135 59.9118 117.443 74.9166 111.419 88.1042C104.304 103.362 87.0902 119.001 60.1353 118.232C31.0182 117.408 5.3605 95.8043 0.571715 67.5173C-0.301158 63.0557 0.571715 60.7937 1.01055 57.1678C0.411956 59.9843 0.0779058 62.8505 0.0127563 65.7291V66.0493C0.0401891 81.5752 5.88997 96.5267 16.4073 107.952C26.9247 119.378 41.3453 126.447 56.8225 127.765C72.2997 129.082 87.7087 124.553 100.008 115.069C112.307 105.586 120.602 91.8389 123.256 76.5413C123.36 75.7409 123.445 74.9484 123.538 74.14C124.816 63.5774 123.432 52.863 119.511 42.9715L119.505 42.9795Z",
    fill: "url(#paint1_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M119.505 42.9795C116.808 36.4928 111.337 29.4891 107.053 27.2751C110.108 33.1885 112.228 39.5391 113.339 46.1011V46.1604L113.35 46.226C118.135 59.9118 117.443 74.9166 111.419 88.1042C104.304 103.362 87.0902 119.001 60.1353 118.232C31.0182 117.408 5.3605 95.8043 0.571715 67.5173C-0.301158 63.0557 0.571715 60.7937 1.01055 57.1678C0.411956 59.9843 0.0779058 62.8505 0.0127563 65.7291V66.0493C0.0401891 81.5752 5.88997 96.5267 16.4073 107.952C26.9247 119.378 41.3453 126.447 56.8225 127.765C72.2997 129.082 87.7087 124.553 100.008 115.069C112.307 105.586 120.602 91.8389 123.256 76.5413C123.36 75.7409 123.445 74.9484 123.538 74.14C124.816 63.5774 123.432 52.863 119.511 42.9715L119.505 42.9795Z",
    fill: "url(#paint2_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M89.331 50.2632C89.4656 50.3577 89.5905 50.4521 89.717 50.5466C88.1578 47.783 86.2168 45.2528 83.9513 43.0306C64.652 23.7403 78.895 1.21639 81.2958 0.0637831L81.3198 0.0285645C65.7282 9.15341 60.4349 26.0424 59.9545 34.4949C60.6784 34.4452 61.3959 34.3844 62.1358 34.3844C67.6675 34.3951 73.0977 35.8696 77.8744 38.6581C82.6511 41.4466 86.6039 45.4495 89.331 50.26V50.2632Z",
    fill: "url(#paint3_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.1679 54.1214C62.0653 55.6646 56.6103 60.9875 54.7028 60.9875C37.0531 60.9875 34.1863 71.6603 34.1863 71.6603C34.9679 80.6475 41.2333 88.053 48.8073 91.9591C49.1532 92.1384 49.504 92.3001 49.8547 92.4586C50.4623 92.7275 51.0698 92.9762 51.6774 93.2045C54.2767 94.1239 56.9992 94.649 59.7542 94.7622C90.6972 96.2125 96.6872 57.7826 74.3592 46.6246C79.6262 45.9396 84.96 47.2341 89.3262 50.257C86.5991 45.4465 82.6463 41.4435 77.8696 38.655C73.0929 35.8666 67.6627 34.392 62.131 34.3813C61.3943 34.3813 60.6736 34.4422 59.9496 34.4918C53.7209 34.9186 47.7656 37.2121 42.8605 41.0729C43.8071 41.8733 44.8754 42.9427 47.1256 45.1599C51.3378 49.3077 62.1406 53.6043 62.1647 54.1086L62.1679 54.1214Z",
    fill: "url(#paint4_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.1679 54.1214C62.0653 55.6646 56.6103 60.9875 54.7028 60.9875C37.0531 60.9875 34.1863 71.6603 34.1863 71.6603C34.9679 80.6475 41.2333 88.053 48.8073 91.9591C49.1532 92.1384 49.504 92.3001 49.8547 92.4586C50.4623 92.7275 51.0698 92.9762 51.6774 93.2045C54.2767 94.1239 56.9992 94.649 59.7542 94.7622C90.6972 96.2125 96.6872 57.7826 74.3592 46.6246C79.6262 45.9396 84.96 47.2341 89.3262 50.257C86.5991 45.4465 82.6463 41.4435 77.8696 38.655C73.0929 35.8666 67.6627 34.392 62.131 34.3813C61.3943 34.3813 60.6736 34.4422 59.9496 34.4918C53.7209 34.9186 47.7656 37.2121 42.8605 41.0729C43.8071 41.8733 44.8754 42.9427 47.1256 45.1599C51.3378 49.3077 62.1406 53.6043 62.1647 54.1086L62.1679 54.1214Z",
    fill: "url(#paint5_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.9695 39.0255C40.4724 39.3457 40.8872 39.6242 41.2508 39.8755C39.8366 34.9272 39.7763 29.6903 41.0762 24.7107C35.3503 27.483 30.2625 31.4133 26.1349 36.2528C26.4376 36.2448 35.4418 36.0831 39.9695 39.0255Z",
    fill: "url(#paint6_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0.560326 67.5204C5.35072 95.8074 31.0068 117.419 60.1239 118.235C87.0788 118.997 104.296 103.357 111.407 88.1074C117.432 74.9197 118.124 59.9149 113.339 46.2291V46.1699C113.339 46.1235 113.329 46.0963 113.339 46.1107L113.35 46.2147C115.552 60.5856 108.239 74.5017 96.8053 83.9308L96.7701 84.0108C74.4918 102.148 53.1745 94.951 48.8662 92.015C48.5651 91.871 48.264 91.721 47.9629 91.5652C34.9755 85.3603 29.6086 73.5396 30.7617 63.3903C27.6788 63.4357 24.6489 62.5866 22.039 60.9457C19.4291 59.3048 17.3513 56.9426 16.0574 54.1454C19.4669 52.0578 23.3544 50.8776 27.3495 50.7173C31.3447 50.557 35.3143 51.4219 38.8802 53.2297C46.2304 56.5644 54.5941 56.8931 62.1835 54.1454C62.1595 53.6411 51.3567 49.3428 47.1445 45.1966C44.8942 42.9794 43.826 41.9117 42.8794 41.1096C42.3679 40.6765 41.8332 40.2715 41.2778 39.8962C40.9095 39.6449 40.4946 39.3727 39.9965 39.0461C35.4688 36.1038 26.4646 36.2655 26.1667 36.2735H26.1379C23.6778 33.1566 23.8508 22.8792 23.9918 20.7324C23.264 21.0248 22.5693 21.3934 21.9193 21.8322C19.7476 23.3814 17.7173 25.1198 15.8524 27.027C13.7196 29.1745 11.7706 31.497 10.0258 33.9698C6.03545 39.6234 3.20488 46.0094 1.69746 52.7622C1.66703 52.8887 -0.538372 62.5258 0.549115 67.5236L0.560326 67.5204Z",
    fill: "url(#paint7_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M83.9495 43.0275C86.2156 45.2522 88.1567 47.7851 89.7153 50.5515C90.0564 50.8092 90.3751 51.0653 90.6458 51.3135C104.719 64.2804 97.3453 82.6101 96.796 83.9068C108.228 74.4922 115.535 60.5664 113.34 46.1908C106.319 28.6935 94.4096 21.6337 84.7039 6.2816C84.2122 5.50518 83.7205 4.72717 83.2416 3.90594C82.9677 3.43689 82.7483 3.01426 82.5577 2.62526C82.1546 1.84493 81.8439 1.02025 81.632 0.167952C81.6323 0.128623 81.6181 0.0905653 81.5921 0.0610394C81.5661 0.0315136 81.5301 0.012586 81.491 0.00786738C81.4528 -0.00262246 81.4124 -0.00262246 81.3741 0.00786738C81.3661 0.00786738 81.3533 0.022275 81.3437 0.0254767C81.3341 0.0286784 81.3133 0.0430861 81.2989 0.0494895C78.8981 1.18769 64.6582 23.726 83.9575 43.0003L83.9495 43.0275Z",
    fill: "url(#paint8_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M90.6443 51.3199C90.3736 51.0718 90.0549 50.8157 89.7138 50.5579C89.5872 50.4635 89.4623 50.369 89.3278 50.2746C84.9615 47.2517 79.6278 45.9572 74.3608 46.6422C96.6871 57.8002 90.6971 96.2205 59.7558 94.7798C57.0008 94.6666 54.2783 94.1415 51.6789 93.2221C51.0714 92.9948 50.4639 92.7462 49.8563 92.4762C49.5056 92.3161 49.1548 92.156 48.8089 91.9767L48.8521 92.0039C53.1668 94.9479 74.4777 102.14 96.756 83.9997L96.7912 83.9196C97.347 82.6229 104.721 64.2932 90.6411 51.3263L90.6443 51.3199Z",
    fill: "url(#paint9_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.1875 71.6506C34.1875 71.6506 37.0528 60.9777 54.704 60.9777C56.6116 60.9777 62.0714 55.6549 62.1691 54.1117C54.5797 56.8594 46.216 56.5308 38.8658 53.196C35.2999 51.3883 31.3303 50.5233 27.3351 50.6836C23.34 50.8439 19.4525 52.0241 16.043 54.1117C17.3369 56.909 19.4147 59.2712 22.0246 60.912C24.6344 62.5529 27.6644 63.4021 30.7473 63.3566C29.5973 73.5012 34.9627 85.3202 47.9485 91.5315C48.2384 91.6708 48.5107 91.8213 48.8086 91.9542C41.2282 88.0401 34.9691 80.6378 34.1875 71.6554V71.6506Z",
    fill: "url(#paint10_radial_1935_20813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M119.505 42.9794C116.808 36.4928 111.337 29.4891 107.053 27.2751C110.108 33.1885 112.228 39.5391 113.339 46.1011L113.35 46.2052C106.332 28.7239 94.4353 21.6641 84.7136 6.31199C84.2219 5.53558 83.7302 4.75757 83.2513 3.93633C82.9775 3.46728 82.758 3.04466 82.5674 2.65565C82.1643 1.87532 81.8536 1.05065 81.6417 0.198348C81.642 0.159018 81.6278 0.120961 81.6018 0.091435C81.5758 0.0619091 81.5398 0.0429815 81.5008 0.0382629C81.4625 0.027773 81.4221 0.027773 81.3839 0.0382629C81.3759 0.0382629 81.363 0.0526705 81.3534 0.0558722C81.3438 0.0590739 81.323 0.0734816 81.3086 0.079885L81.3326 0.0382629C65.741 9.1631 60.4477 26.0521 59.9672 34.5045C60.6912 34.4549 61.4087 34.3941 62.1486 34.3941C67.6803 34.4048 73.1105 35.8793 77.8872 38.6678C82.6639 41.4563 86.6167 45.4592 89.3438 50.2697C84.9776 47.2468 79.6438 45.9524 74.3769 46.6374C96.7032 57.7953 90.7132 96.2157 59.7719 94.7749C57.0169 94.6617 54.2944 94.1367 51.695 93.2173C51.0874 92.99 50.4799 92.7413 49.8724 92.4713C49.5216 92.3112 49.1709 92.1511 48.8249 91.9718L48.8681 91.999C48.5671 91.855 48.2659 91.705 47.9648 91.5492C48.2547 91.6885 48.527 91.839 48.8249 91.9718C41.2445 88.0561 34.9855 80.6538 34.2039 71.6731C34.2039 71.6731 37.0691 61.0002 54.7204 61.0002C56.6279 61.0002 62.0878 55.6774 62.1855 54.1342C62.1614 53.6299 51.3586 49.3316 47.1464 45.1854C44.8962 42.9682 43.8279 41.9005 42.8814 41.0984C42.3698 40.6654 41.8352 40.2603 41.2798 39.885C39.8655 34.9367 39.8052 29.6997 41.1052 24.7202C35.3792 27.4925 30.2914 31.4228 26.1639 36.2623H26.135C23.675 33.1454 23.8479 22.868 23.9889 20.7212C23.2611 21.0136 22.5664 21.3822 21.9164 21.821C19.7447 23.3702 17.7145 25.1086 15.8495 27.0158C13.7244 29.1694 11.7834 31.4972 10.0469 33.9747C6.0566 39.6283 3.22603 46.0142 1.71861 52.767L1.63533 53.1768C1.51841 53.7227 0.994687 56.4954 0.919412 57.0909C0.440374 59.953 0.134447 62.8414 0.0032959 65.7403V66.0605C0.0307287 81.5864 5.88051 96.5379 16.3979 107.963C26.9152 119.389 41.3358 126.458 56.813 127.776C72.2902 129.094 87.6992 124.564 99.9982 115.081C112.297 105.597 120.593 91.8501 123.247 76.5524C123.351 75.752 123.436 74.9596 123.528 74.1512C124.807 63.5886 123.423 52.8742 119.502 42.9826L119.505 42.9794Z",
    fill: "url(#paint11_linear_1935_20813)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1935_20813",
    x1: 111.289,
    y1: 19.8566,
    x2: 8.28378,
    y2: 119.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.301 14.4363) scale(129.409 129.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2528 67.2644) scale(129.409 129.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.269 -14.3791) scale(93.7417 93.6977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8385 100.882) scale(61.6136 61.5847)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.512 56.1609) rotate(-13.5854) scale(32.672 38.2347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6512 9.63389) scale(44.3323 44.3115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.8862 -19.1816) scale(189.149 189.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1651 -8.69915) rotate(83.9732) scale(138.547 90.9688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6513 25.6423) scale(118.07 118.015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1935_20813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.0814 32.0456) scale(129.233 129.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1935_20813",
    x1: 110.04,
    y1: 19.3284,
    x2: 22.4092,
    y2: 107.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.4bd87a65adb3473714b03e6cc21811e5.svg";
export { ForwardRef as ReactComponent };